import { isNonEmptyString } from '@sniptt/guards';

type GetFullNameArgs = {
  firstName: string;
  lastName: string;
};

export const getFullName = ({ firstName, lastName }: GetFullNameArgs) =>
  [firstName.trim(), lastName.trim()].filter(isNonEmptyString).join(' ');
